import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { APIUrlDefault } from "../utils/configuration";
import axios from 'axios';
import Service from "../api/api-service";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuoJ7I7fl4a28zM-S70r9WPYC2LwTzhKE",
  authDomain: "hoani-live.firebaseapp.com",
  projectId: "hoani-live",
  storageBucket: "hoani-live.firebasestorage.app",
  messagingSenderId: "1090502758124",
  appId: "1:1090502758124:web:89ee5f2d5cd8f47f7b5fc9",
  measurementId: "G-VY76ZVZ446"
};

class FirebaseService {
  constructor() {
    this.app = null;
    this.messaging = null;
    this.token = null;
    this.isInitialized = false;
    this.notificationCallbacks = [];
    this.vapidKey = 'BCpPc0P8hL7mKCUD7bKQux-jZeAj5OGif3YPd2D7Mv0Hfy2HfKZ2VqhyYiMzsRQnFYp-bAvj08vRzN5vGKiLmRU'; // This would come from your Firebase project settings
  }

  // Initialize Firebase app
  async initialize() {
    if (this.isInitialized) return;
    
    try {
      // Check if browser supports Firebase Messaging
      const isFirebaseMessagingSupported = await isSupported();
      
      if (!isFirebaseMessagingSupported) {
        console.warn('Firebase Messaging is not supported in this browser');
        return;
      }

      // Initialize Firebase
      this.app = initializeApp(firebaseConfig);
      this.messaging = getMessaging(this.app);
      this.isInitialized = true;
      
      // Set up foreground notification handler
      onMessage(this.messaging, (payload) => {
        console.log('Received foreground message:', payload);
        this.notifyCallbacks(payload);
      });
      
      console.log('Firebase initialized successfully');
    } catch (error) {
      console.error('Error initializing Firebase:', error);
    }
  }

  // Request notification permission and get FCM token
  async requestPermissionAndGetToken() {
    if (!this.isInitialized) {
      await this.initialize();
    }
    
    if (!this.messaging) {
      console.warn('Firebase Messaging not available');
      return null;
    }

    try {
      // Request permission
      const permission = await Notification.requestPermission();
      
      if (permission !== 'granted') {
        console.warn('Notification permission not granted');
        return null;
      }
      
      // Get token
      this.token = await getToken(this.messaging, { vapidKey: this.vapidKey });
      console.log('FCM Token:', this.token);
      
      return this.token;
    } catch (error) {
      console.error('Error getting FCM token:', error);
      return null;
    }
  }

  // Register FCM token with backend
  async registerTokenWithBackend(token) {
    if (!token) {
      token = this.token;
    }
    
    if (!token) {
      console.warn('No FCM token available to register');
      return false;
    }
    
    try {
      // Store deviceId for future reference, even though we don't send it to the API
      const deviceId = localStorage.getItem('deviceId') || `web_${Date.now()}`;
      localStorage.setItem('deviceId', deviceId);
      
      const service = new Service();
      const response = await service.post(
        'api/notifications/register', 
        { token: token }
      );

      console.log('FCM token registered with backend:', response);
      return true;
    } catch (error) {
      console.error('Error registering FCM token with backend:', error);
      return false;
    }
  }

  // Unregister FCM token with backend
  async unregisterTokenWithBackend(token) {
    if (!token) {
      token = this.token;
    }
    
    if (!token) {
      console.warn('No FCM token available to unregister');
      return false;
    }
    
    try {
      const service = new Service();
      const response = await service.delete(
        'api/notifications/unregister', 
        { token: token }
      );
      
      console.log('FCM token unregistered from backend:', response);
      return true;
    } catch (error) {
      console.error('Error unregistering FCM token from backend:', error);
      return false;
    }
  }

  // Add notification callback
  addNotificationCallback(callback) {
    if (typeof callback === 'function' && !this.notificationCallbacks.includes(callback)) {
      this.notificationCallbacks.push(callback);
    }
  }

  // Remove notification callback
  removeNotificationCallback(callback) {
    const index = this.notificationCallbacks.indexOf(callback);
    if (index !== -1) {
      this.notificationCallbacks.splice(index, 1);
    }
  }

  // Notify callbacks about new notifications
  notifyCallbacks(payload) {
    this.notificationCallbacks.forEach(callback => {
      try {
        callback(payload);
      } catch (error) {
        console.error('Error in notification callback:', error);
      }
    });
  }
}

// Create a singleton instance
const firebaseService = new FirebaseService();
export default firebaseService;
